import { Link } from "react-router-dom";

import logoFooter from "../../images/logoFooter.svg";

import "./footer.scss";

function Footer() {
  return (
    <div className="footer">
      <footer className="container-fluid">
        <div className="row">
          <div className="row row-cols-2">
            <div className="col-12 col-lg-4 footer-logo">
              <img src={logoFooter} alt="Logo" />
              <div className="my-3 text-logo">
                Chegamos trazendo
                <br></br>
                diversão, alegria e bem-estar.
              </div>
            </div>
            <div className="col-12 col-lg-8 mt-md-5 mt-lg-0">
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-3 mt-5 mt-sm-0 footer-options">
                  <h4>A ADOLETA</h4>
                  <Link to={"/quem-somos"} className="nav-link">
                    Quem somos
                  </Link>
                  <Link to={"/"} className="nav-link">
                    Brinquedos
                  </Link>
                  <Link to={"/"} className="nav-link">
                    Como funciona
                  </Link>
                  <Link to={"/"} className="nav-link">
                    Vantagens
                  </Link>
                  <Link to={"/duvidas-frequentes"} className="nav-link">
                    Dúvidas frequentes
                  </Link>
                  <Link to={"/contato"} className="nav-link">
                    Contato
                  </Link>
                </div>

                <div className="col-12 col-sm-6 col-lg-3 mt-5 mt-sm-0 footer-options">
                  <h4>FRANQUEADOS</h4>
                  <Link to={"/seja-um-franqueado"} className="nav-link">
                    Seja um franqueado
                  </Link>
                  <Link to={"/"} className="nav-link">
                    Área do franqueado
                  </Link>
                </div>

                <div className="col-12 col-sm-6 col-lg-3 mt-5 mt-sm-0 footer-options">
                  <h4>MINHA CONTA</h4>
                  <Link to={"/"} className="nav-link">
                    Meus pedidos
                  </Link>
                  <Link to={"/"} className="nav-link">
                    Meu carrinho
                  </Link>
                  <Link to={"/"} className="nav-link">
                    Cadastro
                  </Link>
                </div>

                <div className="col-12 col-sm-6 col-lg-3 mt-5 mt-sm-0 footer-options">
                  <h4>NOSSO CANAIS</h4>
                  <Link to={"/"} className="nav-link d-flex align-items-center">
                    <i
                      className="bi bi-instagram me-2"
                      style={{ fontSize: "26px" }}
                    ></i>
                    Instagram
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex bottom-footer">
            <p className="d-flex align-items-center">
              ADOLETA FRANCHISING | Copyright © 2022. Todos os Direitos
              Reservados
            </p>
            <div className="grid gap-3">
              <Link to={"/"} className="px-3 g-col-6">
                Termos de uso
              </Link>
              <Link to={"/"} className="px-3 g-col-6">
                Política de privacidade
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
